import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';
import { AngularFireStorage } from 'angularfire2/storage';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogRef, MatDialog } from '@angular/material';
import { PatientAddEditPage } from '../patient-add-edit/patient-add-edit';
import { DocumentProcessDialogComponent } from '../../components/document-process-dialog/document-process-dialog';
import { PatientProvider } from '../../providers/patient/patient';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-faxes',
  templateUrl: 'program-faxes.html',
})
export class ProgramFaxesPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  user: any;
  rows: any[] = [];
  document: any;
  pdfSrc: any;
  doc_url: SafeResourceUrl;
  displayedColumns = ['date','actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  chartDialogRef: MatDialogRef<DocumentProcessDialogComponent>;
  
  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider,
    public utility: UtilityProvider,
    private afs: AngularFireStorage,
    private sanitizer: DomSanitizer,
    public matDialog: MatDialog,
    private dbPatient: PatientProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };

      this.database
      .getNewDocumentsByProgramIncomplete(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((fax) => {
        this.dataSource = new MatTableDataSource(fax);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (fax.length > 0) {
          this.view(fax[0]);
        }
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave program faxes view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  view(file)  {
    var imagePathReference = this.afs.ref('documents/faxes/' + file.filename);
    imagePathReference.getDownloadURL().toPromise().then(url => {
      this.document = { enrolment_url: url, ...file };
      this.doc_url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    })
  }

  enrolPatient(enrolment)  {
    var imagePathReference = this.afs.ref('documents/faxes/' + enrolment.filename);
    imagePathReference.getDownloadURL().toPromise().then(url => {
      enrolment.enrolmentURL = url;
    });
  }

  sendFax2(url)  {
    var imagePathReference = this.afs.ref('documents/faxes/' + url.filename);
    imagePathReference.getDownloadURL().toPromise().then(url => {});
  }

  startEnrolment()  {
    this.navCtrl.setRoot(PatientAddEditPage, { urldata: { enrolment_doc_url: this.document.enrolment_url, enrolmentment_doc_id: this.document.id }} );
  }

  sendFax(url)  {
    let confirm = this.alertCtrl.create({
      title: "Send Fax",
      message: "Please enter the fax number",
      inputs: [
        {
          name: 'fax_number',
          placeholder: 'fax number',
          type: 'tel'
        }
      ],
      buttons: [
        {
          text: "Cancel",
          handler: () => {}
        },
        {
          text: "Send Fax",
          handler: data => {
            let fax_number = data.fax_number;
            fax_number = fax_number.replace('-','').replace('(','').replace(')','').replace(/\s+/g,'').replace('+', '');
            if(fax_number.startsWith("1")) {
              fax_number = "+" + fax_number;
            } else {
              fax_number = "+1" + fax_number;
            }
            this.database.sendFax(data.fax_number, url).then(response => {
              const toast = this.toastCtrl.create({
                message:
                  "Fax was successfully sent. Your confirmation is: " + response['sid'],
                duration: 3000
              });
              toast.present();
            })
            .catch(err => {
              const errortoast = this.toastCtrl.create({
                message:
                  "The fax could not be sent at this time.  Please try again. Error: " + err,
                duration: 3000
              });
              errortoast.present();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  openDocumentProcessDialog() {
    this.chartDialogRef = this.matDialog.open(DocumentProcessDialogComponent, {
      hasBackdrop: true,
      disableClose: true,
      width: '400px',
      data: { program_id: this.program_id, patientv: false }
    });

    this.chartDialogRef
    .afterClosed()
    .takeUntil(this.ngUnsubscribe)
    .subscribe(result => {
      if(result) {
        this.document.completed = true;
        this.document.ext = 'pdf';
        this.document.url = this.document.enrolment_url;
        const document = { ...this.document, ...result };
        const patient = {
          id: document.patient.id,
          first_name: document.patient.first_name,
          last_name: document.patient.last_name,
          program_patient_id: document.patient.program_patient_id
        }
        delete document.patient;
        delete document.enrolment_url;
        delete document.enrolmentURL;
        this.dbPatient.transferDocument(this.program_id, patient, document, this.user)
        .then(() => {
          this.utility.presentToast('Transfered document to ' + patient.first_name + ' ' + patient.last_name);
        })
        .catch(err => {
          this.utility.presentToast('Error transferring document');
        });
     }
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/program-faxes/program-faxes.ts